import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 36,
  height: 36,
}

const kitchenCabinet = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 35.666 35.667'
  >
    <g fill={color}>
      <path
        transform='translate(-127.023 -285.8)'
        d='M152.584,307.2H137.128a.594.594,0,0,0-.594.594v13.078a.594.594,0,0,0,.594.594h15.456a.594.594,0,0,0,.594-.594V307.794A.594.594,0,0,0,152.584,307.2Zm-.594,13.078H137.723V308.389h14.267Z'
      />
      <path
        transform='translate(-127.023 -279.8)'
        d='M152.584,307.2H137.128a.594.594,0,0,0-.594.594v13.078a.594.594,0,0,0,.594.594h15.456a.594.594,0,0,0,.594-.594V307.794A.594.594,0,0,0,152.584,307.2Zm-.594,13.078H137.723V308.389h14.267Z'
      />
      <path
        transform='translate(0 -279.8)'
        d='M10.106,307.2H.594a.594.594,0,0,0-.594.594v13.078a.594.594,0,0,0,.594.594h9.511a.594.594,0,0,0,.594-.594V307.794A.594.594,0,0,0,10.106,307.2Zm-.594,13.078H1.189V308.389H9.511v11.889Z'
      />
      <path
        transform='translate(-333.433 -285.8)'
        d='M368.506,307.2h-9.511a.594.594,0,0,0-.594.594v13.078a.594.594,0,0,0,.594.594h9.511a.594.594,0,0,0,.594-.594V307.794A.594.594,0,0,0,368.506,307.2Zm-.595,13.078h-8.322V308.389h8.322v11.889Z'
      />
      <path
        transform='translate(-158.778 -349.311)'
        d='M181.961,375.467h-10.7a.594.594,0,0,0-.594.594v5.944a.594.594,0,0,0,.594.594h10.7a.594.594,0,0,0,.594-.594v-5.944A.594.594,0,0,0,181.961,375.467Zm-.594,5.944h-9.511v-4.756h9.511v4.756Z'
      />
      <rect transform='translate(18.428 23.778)' width='1.189' height='1.189' />
      <rect transform='translate(16.05 23.778)' width='1.189' height='1.189' />
      <rect transform='translate(13.672 23.778)' width='1.189' height='1.189' />
      <rect transform='translate(20.806 23.778)' width='1.189' height='1.189' />
      <rect transform='translate(0.594 26.156)' width='9.511' height='1.189' />
      <rect transform='translate(4.161 23.778)' width='2.378' height='1.189' />
      <rect transform='translate(4.161 28.533)' width='2.378' height='1.189' />
      <rect transform='translate(25.561 26.156)' width='9.511' height='1.189' />
      <rect transform='translate(29.722 26.75)' width='1.189' height='8.322' />
      <rect transform='translate(29.128 23.778)' width='2.378' height='1.189' />
      <rect transform='translate(27.344 29.722)' width='1.189' height='1.783' />
      <rect transform='translate(32.1 29.722)' width='1.189' height='1.783' />
      <path
        transform='translate(-134.96)'
        d='M160.347,9.685l-2.2-2.2V.594A.594.594,0,0,0,157.549,0h-9.511a.6.6,0,0,0-.594.594V7.482l-2.2,2.2a.594.594,0,0,0,.42,1.015h14.267a.594.594,0,0,0,.42-1.015Zm-13.252-.174,1.363-1.363a.593.593,0,0,0,.174-.42V1.189h8.322V7.728a.593.593,0,0,0,.174.42l1.363,1.363h-11.4Z'
      />
      <path
        transform='translate(-396.945 -174.655)'
        d='M429.045,187.733a2.38,2.38,0,0,0-2.378,2.378v.594h1.189v-.594a1.189,1.189,0,1,1,2.378,0v6.539h1.189v-6.539A2.38,2.38,0,0,0,429.045,187.733Z'
      />
      <rect transform='translate(32.1 19.022)' width='1.783' height='1.189' />
      <path
        transform='translate(-142.901 -238.167)'
        d='M160.14,256H154.2a.594.594,0,0,0-.594.594v3.567a.594.594,0,0,0,.594.594h5.944a.594.594,0,0,0,.594-.594v-3.567A.594.594,0,0,0,160.14,256Zm-.594,3.567H154.79v-2.378h4.756Z'
      />
      <rect transform='translate(9.511 19.022)' width='1.783' height='1.189' />
      <rect transform='translate(17.239 19.022)' width='1.783' height='1.189' />
      <path d='M10.106,0H.594A.6.6,0,0,0,0,.594V7.728a.6.6,0,0,0,.594.594h9.511a.6.6,0,0,0,.594-.594V.594A.6.6,0,0,0,10.106,0ZM9.511,7.133H1.189V1.189H9.511V7.133Z' />
      <rect transform='translate(7.133 3.567)' width='1.189' height='2.378' />
      <path
        transform='translate(-333.433)'
        d='M368.506,0h-9.511a.594.594,0,0,0-.594.594V7.728a.594.594,0,0,0,.594.594h9.511a.594.594,0,0,0,.594-.594V.594A.594.594,0,0,0,368.506,0Zm-.595,7.133h-8.322V1.189h8.322V7.133Z'
      />
      <rect transform='translate(27.344 3.567)' width='1.189' height='2.378' />
      <rect transform='translate(0 11.889)' width='10.7' height='1.189' />
      <rect transform='translate(1.189 10.7)' width='1.189' height='5.35' />
      <path
        transform='translate(0 -206.411)'
        d='M1.783,221.867a1.783,1.783,0,1,0,1.783,1.783A1.786,1.786,0,0,0,1.783,221.867Zm0,2.378a.594.594,0,1,1,.594-.594A.6.6,0,0,1,1.783,224.245Z'
      />
      <rect transform='translate(3.567 10.7)' width='1.189' height='5.35' />
      <path
        transform='translate(-31.755 -206.411)'
        d='M35.916,221.867A1.783,1.783,0,1,0,37.7,223.65,1.786,1.786,0,0,0,35.916,221.867Zm0,2.378a.594.594,0,1,1,.594-.594A.6.6,0,0,1,35.916,224.245Z'
      />
      <rect transform='translate(5.944 10.7)' width='1.189' height='5.35' />
      <path
        transform='translate(-63.511 -206.411)'
        d='M70.05,221.867a1.783,1.783,0,1,0,1.783,1.783A1.786,1.786,0,0,0,70.05,221.867Zm0,2.378a.594.594,0,1,1,.594-.594A.6.6,0,0,1,70.05,224.245Z'
      />
    </g>
  </svg>
)

export default kitchenCabinet
